import { Artikel } from '@/modules/ewwms/models/Lager/ArtikelModels';

export type State = {
  artikel: Array<Artikel>;
};

export const state: State = {
  artikel: sessionStorage.getItem('artikel') != null ? JSON.parse(sessionStorage.artikel) : new Array<Artikel>(),
};
